import { VerticalSpacing } from "../../VerticalSpacing"
import { V3BodyGrey35 } from "../../ReusableStyledComponents/V3BodyGrey35";
import { RightAlignPanel } from "../../ReusableStyledComponents/RightAlignPanel";
import { V3Button } from "../../Button";
import { V3CaptionGrey35 } from "../../ReusableStyledComponents/V3CaptionGrey35";
import { V3CopyToClipboard } from "../../V3CopyToClipobard";
import { V3ButtonColor } from "../../Button/V3Button.types";

interface AddContentEmailFinishedProps {
    email: string,
    sourceName: string,
    onCloseHandler: () => void,
    onBackHandler: () => void,
}

export const AddContentEmailFinished = ({ email, sourceName, onCloseHandler, onBackHandler }: AddContentEmailFinishedProps) => {

    return <>
        <VerticalSpacing bottom={18}>
            <VerticalSpacing bottom={24}>
                <V3CaptionGrey35>Any email you forward to the address below will automatically be added to the source <strong>{sourceName}</strong>. You can close this window after copying the secret email.</V3CaptionGrey35>
            </VerticalSpacing>
            <VerticalSpacing bottom={6}>
                <V3BodyGrey35><strong>Secret email address for {sourceName}</strong></V3BodyGrey35>
            </VerticalSpacing>
            <V3CopyToClipboard
                url={email}
                copyText="Copy email address"
            />
        </VerticalSpacing>
        <VerticalSpacing bottom={24}>
            <V3CaptionGrey35>Please note: Once you've forwarded an email, it will take about 30 seconds until it appears in your Authory account.</V3CaptionGrey35>
        </VerticalSpacing>
        <RightAlignPanel>
            <div>
                <V3Button
                    type="button"
                    text="Back"
                    color={V3ButtonColor.secondary}
                    onClick={(e) => {
                        e.preventDefault();
                        onBackHandler();
                    }}
                />
            </div>
            <div>
                <V3Button
                    text={"Close"}
                    onClick={onCloseHandler}
                />
            </div>
        </RightAlignPanel>
    </>
}